import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { IconsService } from '../services/icons.service';
import { GodModeService } from '../services/god-mode.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-god-mode-toggle',
  template: `
    <div class="god-mode-toggle" 
         [class.active]="isGodMode" 
         (click)="toggleGodMode()"
         *ngIf="authService.hasPermission('can_god_mode')">
      <fa-icon [icon]="icons.faUserShield" class="god-mode-icon"></fa-icon>
      <span class="god-mode-text">{{ isGodMode ? 'DIOS' : 'USER' }}</span>
    </div>
  `,
  styles: [`
    .god-mode-toggle {
      position: fixed;
      top: 20px;
      right: 20px;
      width: 60px;
      height: 60px;
      background: linear-gradient(135deg, #6c757d, #495057);
      border: 2px solid #dee2e6;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 9999;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      user-select: none;
    }

    .god-mode-toggle:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }

    .god-mode-toggle.active {
      background: linear-gradient(135deg, #ffd700, #ffb347);
      border-color: #ffd700;
      animation: pulse 2s infinite;
    }

    .god-mode-toggle.active:hover {
      background: linear-gradient(135deg, #ffb347, #ff8c00);
    }

    .god-mode-icon {
      font-size: 16px;
      color: white;
      margin-bottom: 2px;
    }

    .god-mode-text {
      font-size: 8px;
      font-weight: bold;
      color: white;
      line-height: 1;
      text-align: center;
    }

    @keyframes pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.7);
      }
      70% {
        box-shadow: 0 0 0 10px rgba(255, 215, 0, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(255, 215, 0, 0);
      }
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .god-mode-toggle {
        width: 50px;
        height: 50px;
        top: 15px;
        right: 15px;
      }
      
      .god-mode-icon {
        font-size: 14px;
      }
      
      .god-mode-text {
        font-size: 7px;
      }
    }
  `]
})
export class GodModeToggleComponent implements OnInit, OnDestroy {
  isGodMode: boolean = false;
  private godModeSubscription: Subscription = new Subscription();

  constructor(
    public icons: IconsService,
    public authService: AuthService,
    private godModeService: GodModeService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.godModeSubscription = this.godModeService.godMode$.subscribe(
      (godMode: boolean) => {
        this.isGodMode = godMode;
      }
    );
  }

  ngOnDestroy(): void {
    this.godModeSubscription.unsubscribe();
  }

  toggleGodMode(): void {
    // Double-check permission before allowing toggle
    if (!this.authService.hasPermission('can_god_mode')) {
      this.toastr.error('No tienes permisos para activar el modo Dios', 'Acceso Denegado');
      return;
    }

    const newGodMode = this.godModeService.toggleGodMode();
    
    if (newGodMode) {
      this.toastr.warning('Modo Dios activado - Acceso completo habilitado', 'God Mode', {
        timeOut: 3000,
        positionClass: 'toast-top-right'
      });
    } else {
      this.toastr.info('Modo Usuario activado - Permisos estándar', 'User Mode', {
        timeOut: 3000,
        positionClass: 'toast-top-right'
      });
    }

    // Optionally reload the page to apply changes immediately
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}
